import basicdata from '@kaili/api/api.basicdata'
export default [
  {
    type: 'input',
    placeholder: '设备SN码',
    filed: 'assetNumber',
    default: ''
  },
  {
    type: 'input',
    placeholder: '设备IMEI',
    filed: 'imei',
    default: ''
  },
  {
    type: 'cascader',
    placeholder: '设备类型型号',
    filed: 'typeNumber',
    default: [],
    query: basicdata.device_model_cascade
  },
  {
    type: 'department',
    placeholder: '负责部门',
    filed: 'department',
    params: {
      departOne: 'departOne',
      departTwo: 'departTwo',
      departThree: 'departThree',
      departFour: 'departFour',
      departFive: 'departFive'
    },
    default: ''
  },
  {
    type: 'input',
    placeholder: '门店名称',
    filed: 'shopName',
    default: ''
  },
  {
    type: 'select',
    placeholder: '门店绑定状态',
    filed: 'shopBind',
    default: '',
    options: [
      {
        code: 0,
        name: '未绑定'
      },
      {
        code: 1,
        name: '已绑定'
      }
    ]
  },
  {
    type: 'select',
    placeholder: '在线状态',
    filed: 'online',
    default: '',
    options: [
      {
        code: 'offline',
        name: '离线'
      },
      {
        code: 'online',
        name: '在线'
      }
    ]
  },
  {
    type: 'select',
    placeholder: 'APP参数修改状态',
    filed: 'appChange',
    default: '',
    options: [
      {
        code: 0,
        name: '未修改'
      },
      {
        code: 1,
        name: '已修改'
      }
    ]
  }
]
